import React from 'react';
import * as styles from './Divider.module.scss';
import { clsx } from '../utils/utils';

import dividerImage from '../images/divider.svg';

export interface DividerProps {
  className?: string;
}

const Divider = ({ className }: DividerProps): React.ReactElement => {
  return <img className={clsx(styles.image, className)} src={dividerImage}></img>;
};

export default Divider;
